import { fetchClaimedDomainsIfNeeded } from './claimed-domains-action-creators';
import { fetchUnclaimedDomainsIfNeeded } from './unclaimed-domains-action-creators';
import { fetchSuggestedDomainsIfNeeded } from '../../common/actions/suggested-domains-action-creators';

import {
    claimedCurrentPageSelector,
    claimedFilterParamsSelector,
    claimedParamsSelector,
} from '../../common/selectors/claimed-domains-with-counts-selectors';

import {
    unclaimedCurrentPageSelector,
    unclaimedFilterParamsSelector,
    unclaimedParamsSelector,
} from '../../common/selectors/unclaimed-domains-with-counts-selectors';

import {
    suggestedDomainsCurrentPageSelector,
    suggestedDomainsParamsSelector,
    suggestedDomainsFilterParamsSelector
} from '../../common/selectors/suggested-domains-selectors';

import {
    DOMAIN_MANAGEMENT_TABLE_TYPE_CLAIMED,
    DOMAIN_MANAGEMENT_TABLE_TYPE_DISCOVERED,
    DOMAIN_HIERARCHY_PARENT,
    DOMAIN_HIERARCHY_SUBDOMAIN,
} from '../../common/constants/definitions';

const claimedDomainMethodsMap = () => {
    return {
        currentPage: claimedCurrentPageSelector,
        currentParams: claimedParamsSelector,
        fetchData: fetchClaimedDomainsIfNeeded,
        filterParams: claimedFilterParamsSelector,
    };
};

const discoveredDomainMethodsMap = ( hierarchy ) => {
    const hierarchyMap = {
        [DOMAIN_HIERARCHY_PARENT]: {
            currentPage: unclaimedCurrentPageSelector,
            currentParams: unclaimedParamsSelector,
            fetchData: fetchUnclaimedDomainsIfNeeded,
            filterParams: unclaimedFilterParamsSelector
        },
        [DOMAIN_HIERARCHY_SUBDOMAIN]: {
            currentPage: suggestedDomainsCurrentPageSelector,
            currentParams: suggestedDomainsParamsSelector,
            fetchData: fetchSuggestedDomainsIfNeeded,
            filterParams: suggestedDomainsFilterParamsSelector
        },
    };

    return hierarchyMap[hierarchy];
};

const domainManagementMap = {
    [DOMAIN_MANAGEMENT_TABLE_TYPE_CLAIMED]: claimedDomainMethodsMap,
    [DOMAIN_MANAGEMENT_TABLE_TYPE_DISCOVERED]: discoveredDomainMethodsMap,
};

export function filterDomainManagementTable( type, hierarchy, filterParams ){
    return ( dispatch, getState ) => {
        const state = getState();
        const metadata = domainManagementMap[type]( hierarchy );

        const currentParams = metadata.currentParams( state );

        // preserve any existing sort states, reset pagination
        const fetchParams = {
            ...currentParams,
            pageNum: 1
        };

        dispatch( metadata.fetchData( fetchParams, filterParams ) );
    };
}

export function paginateDomainManagementTable( type, hierarchy ){
    return ( dispatch, getState ) => {
        const state = getState();
        const metadata = domainManagementMap[type]( hierarchy );

        const currentParams = metadata.currentParams( state );
        const filterParams = metadata.filterParams( state );
        const currentPage = metadata.currentPage( state );

        const fetchParams = {
            ...currentParams,
            pageNum: currentPage + 1
        };

        dispatch( metadata.fetchData( fetchParams, filterParams ) );
    };
}

export function sortDomainManagementTable( type, hierarchy, sortParams ){
    return ( dispatch, getState ) => {
        const state = getState();
        const metadata = domainManagementMap[type]( hierarchy );

        const currentParams = metadata.currentParams( state );
        const filterParams = metadata.filterParams( state );

        // preserve any existing sort states, reset pagination
        const fetchParams = {
            ...currentParams,
            ...sortParams,
            pageNum: 1
        };

        dispatch( metadata.fetchData( fetchParams, filterParams ) );
    };
}

